
import { Document } from '@contentful/rich-text-types';
import { articleStyles } from '../../style/article';
import RichText from '../contentful/RichText';
import FollowCTA from './FollowCTA';

export default function JustTheGist({ document }: { document: Document }) {
  return (
    <div css={[articleStyles]}>
      <h2>Just the gist</h2>
      <p>Short on time? Here’s what you need to know for this update.</p>
      <RichText document={document} />
      <FollowCTA />
    </div>
  );
}
